// import Couchdb from 'src/services/Couchdb'

// const moment = require('moment')
// require('moment/locale/pt-br')

const cpfIsValidRule = {
  getMessage (field, args) {
    return 'CPF inválido.'
  },
  validate (value, args) {
    let cpf = value
    cpf = cpf.replace(/[^\d]+/g, '')
    if (cpf === '') return false

    if (cpf.length !== 11 ||
      cpf === '00000000000' ||
      cpf === '11111111111' ||
      cpf === '22222222222' ||
      cpf === '33333333333' ||
      cpf === '44444444444' ||
      cpf === '55555555555' ||
      cpf === '66666666666' ||
      cpf === '77777777777' ||
      cpf === '88888888888' ||
      cpf === '99999999999'
    ) {
      return false
    }

    let add = 0
    for (let i = 0; i < 9; i++) add += parseInt(cpf.charAt(i)) * (10 - i)
    let rev = 11 - add % 11
    if (rev === 10 || rev === 11) rev = 0
    if (rev !== parseInt(cpf.charAt(9))) return false

    add = 0
    for (let i = 0; i < 10; i++) add += parseInt(cpf.charAt(i)) * (11 - i)
    rev = 11 - add % 11
    if (rev === 10 || rev === 11) rev = 0
    if (rev !== parseInt(cpf.charAt(10))) return false
    return true
  }
}

// const customerAlreadyWonRule = {
//   getMessage (field, args, data) {
//     let exchangeDate = moment(data.exchangeDate)
//     return 'Cliente já foi contemplado anteriomente. Em ' + exchangeDate.format('DD/MM/YYYY HH:mm:ss')
//   },
//   validate (value, [field1, field2]) {
//     return new Promise((resolve, reject) => {
//       Couchdb.connection('winners')
//       if (field2 !== undefined) {
//         Couchdb.where(field2, document.getElementById('uc').value) // Pequena gambiara para recuperar a UC do cliente.
//       }

//       Couchdb.where(field1, value).first()
//       .then(doc => {
//         if (doc === null) {
//           resolve({
//             valid: true,
//             data: doc
//           })
//         } else {
//           resolve({
//             valid: false,
//             data: doc
//           })
//         }
//       })
//     })
//   }
// }

// export { cpfIsValidRule, customerAlreadyWonRule }
export { cpfIsValidRule }



// WEBPACK FOOTER //
// ./src/services/ValidationRules.js